import { AuthUserType } from '@sdk/authentication/types/AuthUserType';

import { ConversationState } from '@web/conversations/Conversation/ConversationProvider/conversationProvider.types';

export const canLeaveConversation = (
  currentUser: AuthUserType,
  conversation: ConversationState
) => {
  return (
    !conversation.isPrivate &&
    currentUser.allTypeGroupIds.every((groupId) => !conversation.memberIds.includes(groupId))
  );
};

export const canEditOrDeleteConversation = (
  currentUser: AuthUserType,
  conversation: ConversationState
) => {
  const isCreator = currentUser.id === conversation.creatorId;

  return (
    !conversation.isPrivate && !conversation.isDisabled && (currentUser.isManager || isCreator)
  );
};
